import "./fix-webpack-path";
import { createRoot } from "react-dom/client";
import { StrictMode, lazy, Suspense } from "react";
import { kcContext as kcLoginThemeContext } from "./keycloak-theme/login/kcContext";
import { kcContext as kcAccountThemeContext } from "./keycloak-theme/account/kcContext";

const KcLoginThemeApp = lazy(() => import("./keycloak-theme/login/KcApp"));
const KcAccountThemeApp = lazy(() => import("./keycloak-theme/account/KcApp"));
const App = lazy(() => import("./App"));

const isLikelyKeycloakPage =
  typeof window !== "undefined" &&
  /(\/realms\/|\/auth\/realms\/)/.test(window.location.pathname);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Suspense>
      {(() => {
        if (kcLoginThemeContext !== undefined) {
          return <KcLoginThemeApp kcContext={kcLoginThemeContext} />;
        }

        if (kcAccountThemeContext !== undefined) {
          return <KcAccountThemeApp kcContext={kcAccountThemeContext} />;
        }

        if (isLikelyKeycloakPage) {
          console.error(
            "Keycloak context is missing on an auth page. Refusing SPA fallback."
          );
          return null;
        }

        return <App />;
      })()}
    </Suspense>
  </StrictMode>
);
